import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import './RatingModal.scss';

export default function RatingModal({ show, onHide, termin, onConfirm }) {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) {
      setError('Bitte wähle mindestens 1 Stern aus.');
      return;
    }
    setError('');
    onConfirm(termin.id, rating, feedback);
    setRating(0);
    setFeedback('');
    onHide();
  };

  const handleClose = () => {
    setRating(0);
    setFeedback('');
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="retro-modal rating-modal">
      <Modal.Header closeButton>
        <Modal.Title className="modal-title-serif">Unterricht bewerten</Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="text-center mb-4">
            <p className="lead-text">Wie war deine Lerneinheit in <strong>{termin?.skillName || termin?.fach?.name || 'Nachhilfe'}</strong>?</p>
            <p className="sub-text text-muted">Deine Bewertung hilft uns, die Plattform noch besser zu machen.</p>
          </div>

          <div className="star-rating-container d-flex flex-column align-items-center mb-4">
            <div className="star-rating-wrap d-flex gap-2">
              {[1, 2, 3, 4, 5].map((star) => {
                const isFilled = star <= (hoverRating || rating);
                return (
                  <span
                    key={star}
                    className={`star-icon-btn ${isFilled ? 'filled' : ''}`}
                    onMouseEnter={() => setHoverRating(star)}
                    onMouseLeave={() => setHoverRating(0)}
                    onClick={() => setRating(star)}
                  >
                    <i className={`bi ${isFilled ? 'bi-star-fill' : 'bi-star'}`} />
                  </span>
                );
              })}
            </div>
            {rating > 0 && (
              <span className="rating-badge mt-2">
                {rating} von 5 Sternen
              </span>
            )}
            {error && <div className="text-danger mt-2 small fw-bold">{error}</div>}
          </div>

          <Form.Group controlId="ratingFeedback" className="mb-3">
            <Form.Label className="form-label-serif">Dein Feedback (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Teile uns mit, was dir besonders gefallen hat oder was wir verbessern können..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="retro-textarea"
            />
          </Form.Group>
        </Modal.Body>
        
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="link" className="btn-cancel" onClick={handleClose}>
            Abbrechen
          </Button>
          <Button type="submit" className="btn-submit-rating">
            <i className="bi bi-check-circle me-2"></i> Bewertung abgeben
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
